export const scrollIntoView = (selector) => {
    const collectionProductsElement = document.querySelector(selector);
    collectionProductsElement.scrollIntoView({
        behavior: 'smooth', block: 'start',
    });
};
